export enum SSOLoginUrls {
  QA = 'https://business-qa.townsq.io/sso',
  UAT = 'https://business-uat.townsq.io/sso',
  PROD_BR = 'https://business.townsq.com.br/sso',
  PROD_US = 'https://business.townsq.io/sso',
}
